var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from "react";
import { Box } from "theme-ui";
import { randomId } from "../../utils";
import { ColorSwatch } from "./ColorSwatch";
import { OutOfStockColorSwatch } from "./OutOfStockColorSwatch";
import { SelectedColorSwatch } from "./SelectedColorSwatch";
export const SwatchIcon = props => {
    if (props.selected) {
        return _jsx(SelectedColorSwatch, Object.assign({}, props));
    }
    else if (props.inStock) {
        return _jsx(ColorSwatch, Object.assign({}, props));
    }
    else {
        return _jsx(OutOfStockColorSwatch, Object.assign({}, props));
    }
};
export const RadioSwatch = React.forwardRef((_a, ref) => {
    var { id = randomId(), hexColor, swatchSize = 20, inStock, variant = "radio", className, sx } = _a, props = __rest(_a, ["id", "hexColor", "swatchSize", "inStock", "variant", "className", "sx"]);
    return (_jsxs(Box, { sx: {
            minWidth: "min-content",
            cursor: inStock ? "pointer" : "inherit"
        }, children: [_jsxs(Box, { sx: {
                    position: "absolute",
                    opacity: 0,
                    zIndex: -1,
                    width: 1,
                    height: 1,
                    overflow: "hidden"
                }, children: [_jsx("label", { htmlFor: id, children: props.value }), _jsx("input", Object.assign({ id: id, type: "radio", disabled: !inStock }, props))] }), _jsx("label", { htmlFor: id, sx: { cursor: "pointer" }, children: _jsx(Box, { as: () => (_jsx(SwatchIcon, { color: hexColor, size: swatchSize, selected: props.defaultChecked || false, inStock: inStock })), "aria-hidden": "true", variant: variant, className: className, sx: sx }) })] }));
});
//# sourceMappingURL=RadioSwatch.js.map